import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import { FullscreenOutlined } from '@ant-design/icons';
import { useMap } from '../../../contexts/MapContext';
import ExchangeIcon from '../../../assets/icons/confronto.svg';
import './styles.css';

const CompareButton = () => {
  const { isCompareMode: compareMode, toggleCompareMode: handleToggleCompare } = useMap();

  // selectMode is not found in the codebase, defaulting to false
  const selectMode = false;

  return (
    <AntTooltip title={compareMode ? "Esci dal Confronto" : "Compara Scenario"} placement="bottom">
      <button
        className={`sidebar-button-confronto ${compareMode ? 'active' : ''}`}
        onClick={handleToggleCompare}
        disabled={selectMode}
      >
        {compareMode ? (
          <FullscreenOutlined />
        ) : (
          <img src={ExchangeIcon} alt="Confronto" className="confronto-icon" />
        )}
        <span>{compareMode ? 'Esci' : 'Confronto'}</span>
      </button>
    </AntTooltip>
  );
};

export default CompareButton;

